import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { useNavigate } from 'react-router';
import { pages } from '@/settings/pages';

export const ActivationSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const title = t('pages.activation.success.title');

  setTimeout(() => {
    navigate(pages.signin.index);
  }, 2000);

  return (
    <PageRootWrapper
      title={title}
      headerTitle={t('pages.activation.success.prompt')}
      breadcrumbItems={[{ label: t('pages.activation.success.prompt') }]}
      containerType="normal"
    >
      <p className="message">{t('text.activation.success.done')}</p>
    </PageRootWrapper>
  );
};
